/*
*
* File JS per la Pagina Raccolta Differenziata
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
// import 'debug.addIndicators';

//--------------------------------------------------------------------//


// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSimple from 'components/hero-simple/hero-simple';

import sectionPageCustom from 'sections/section-page-custom/section-page-custom';

import featuredBrands from 'components/featured-brands/featured-brands';

//--------------------------------------------------------------------//


// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './raccolta-differenziata.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

sectionPageCustom();

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const initPackagingList = () => {
    let packagingList = document.querySelector('.packaging-list');

    if (!packagingList) return;

    let stickyMenu = document.querySelector(".packaging-list__menu");
    let allRows = document.querySelectorAll('.packaging-list__row');
    let allNavLinks = stickyMenu.querySelectorAll('a.scroll-to');

    // Observer sticky menu
    let stickyMenuOffset = document.querySelector(".packaging-list").offsetTop -75;

    window.addEventListener('resize', function()
    {
        stickyMenuOffset = document.querySelector(".packaging-list").offsetTop -75;
    });

    window.addEventListener('scroll', function()
    {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll >= stickyMenuOffset) 
        {
            stickyMenu.classList.add('is-sticky');
        }
        else
        {
            stickyMenu.classList.remove('is-sticky');
        }
    });
    // ----------- //


    // Manage active links
    let controller = new ScrollMagic.Controller();
    let allScene = [];

    if (!allRows) return;

    /**
    *	Funzione toggle class active
    */
    let manageClassNav = (index) => {

        allNavLinks.forEach(el => {
            el.classList.remove('active');
        });

        allNavLinks[index].classList.add('active');

        // scroll orizzontale nav in versione mobile
        if (window.innerWidth < 1024) {
            stickyMenu.querySelector('.container').scroll({
                left: (allNavLinks[index].offsetLeft - 25),
                top: 0,
                behavior: 'smooth'
            });
        }
    }

    allRows.forEach((el, index) => {

        allScene[index] = new ScrollMagic.Scene({
                triggerElement: el,
                duration: el.offsetHeight,
                triggerHook: 0.3,
            })
            // .addIndicators()
            .setClassToggle(el, "on-view") // add class toggle
            .on("enter", () => {
                manageClassNav(index);
            })
            .addTo(controller);

    });

    // ----------- //

}
initPackagingList();

//--------------------------------------------------------------------//